import React, { useState, useEffect, useRef } from "react";
import { SellerNav } from "./DealerNav";
import api from "../api";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce"; // Import debounce function
export const BuyNow = () => {
    const navigate = useNavigate();
      const [VehicleListCount, setVehicleCount] = useState(0); // State for vehicle count
      const [posts, setPosts] = useState([]);
      const [error, setError] = useState(null);
      const storedDealerId = sessionStorage.getItem("user_id");
      const [isNewUser, setIsNewUser] = useState(false);
      const [year, setYear] = useState("");
      const [model, setModel] = useState("");
      const [mileage, setMileage] = useState("");
      const [loading, setLoading] = useState(true); // Add a loading state
      const [makes, setMakes] = useState([]);
      const [years, setYears] = useState([]);
      const [selectedMakes, setSelectedMakes] = useState([]);
      const [selectedYear, setSelectedYear] = useState("");
      const [isOpen, setIsOpen] = useState(false);
      const [models, setModels] = useState([]); // List of models
      const toggleDropdown = () => setIsOpen(!isOpen);
      const [selectedModel, setSelectedModel] = useState("");
      const [isModelOpen, setIsModelOpen] = useState(false);
      const dropdownRef = useRef(null);
      const modelDropdownRef = useRef(null);
      const toggleModelDropdown = () => setIsModelOpen((prev) => !prev);
      const [totalPostsCount, setTotalPostsCount] = useState(0);
      const handleMakeCheckboxChange = (makeId) => {
        setSelectedMakes((prev) =>
          prev.includes(makeId)
            ? prev.filter((id) => id !== makeId)
            : [...prev, makeId]
        );
      };
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false); // Close dropdown if click is outside
        }
        if (
          modelDropdownRef.current &&
          !modelDropdownRef.current.contains(event.target)
        ) {
          setIsModelOpen(false); // Close dropdown if click is outside
        }
      };
    
      useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
      }, []);
      useEffect(() => {
        // Add event listener to handle clicks outside
        document.addEventListener("mousedown", handleClickOutside);
    
        // Cleanup event listener when component is unmounted
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
    
      useEffect(() => {
        sessionStorage.removeItem("isNewUser");
        setIsNewUser(false);
        const fetchPosts = debounce(async () => {
          try {
            if (!storedDealerId) {
              navigate("/sellerin");
              return; // Stop further execution
            }
            const response = await api.get(
              `/vehiclelisting/${storedDealerId}/Buyer/BuyNow`
            );
            console.log("buy data test",response)
            const { message, Vehicle } = response.data;
            // Check if message is true and Vehicle is an array
            if (message && Array.isArray(Vehicle)) {
              // Log the entire response data
              // Set the Vehicle data in state
              setVehicleCount(Vehicle.length); // Count the number of vehicles
              setPosts(Vehicle);
              setLoading(false);
            } else {
              throw new Error("Invalid data format: Vehicle array not found");
            }
          } catch (error) {
            setError(error.message);
            setLoading(false);
          }
        }, 1000);
        fetchPosts();
      }, [navigate, storedDealerId]);
    
    
    return (
     <section className="car-details">
           <SellerNav />
           <div className="container">
             <div className="view-post-panel mid-table mt-4">
               <div class="toplisting">
                 <h3 className="main-heading py-3">Buy Now</h3>
               </div>
               <div className="car-bid-gallary">
                 <div className="carbid-gallery-panel py-4">
                   <div className="row">
                     {loading ? (
                       <p>Loading...</p> // Render loading state while fetching data
                     ) : posts.length === 0 ? (
                       <div className="col-md-12">
                         <p className="text-center text-danger">No Upcoming Cars</p>
                       </div>
                     ) : (
                       posts.map((post) => (
                         <div key={post.id} className="col-lg-4 col-12">
                           <a href={`/buy-now-car-details/${post.Vehicle_Id}`}>
                             <div className="carbid-image-panel">
                               {/* Replace 'your_static_id' with your desired static ID */}
                               {post.Exterior_Image && (
                                 <img
                                   src={`https://backend.carchaser.ca/uploads/${post.Vehicle_Id}/${post.Exterior_Image}`}
                                   alt="Car"
                                 />
                               )}
                               {post.Exterior_Image2 && !post.Exterior_Image && (
                                 <img
                                   src={`https://backend.carchaser.ca/uploads/${post.Vehicle_Id}/${post.Exterior_Image2}`}
                                   alt="Car"
                                 />
                               )}
                               {post.Exterior_Image3 &&
                                 !post.Exterior_Image2 &&
                                 !post.Exterior_Image && (
                                   <img
                                     src={`https://backend.carchaser.ca/uploads/${post.Vehicle_Id}/${post.Exterior_Image3}`}
                                     alt="Car"
                                   />
                                 )}
                               {post.Exterior_Image4 &&
                                 !post.Exterior_Image3 &&
                                 !post.Exterior_Image2 &&
                                 !post.Exterior_Image && (
                                   <img
                                     src={`https://backend.carchaser.ca/uploads/${post.Vehicle_Id}/${post.Exterior_Image4}`}
                                     alt="Car"
                                   />
                                 )}
                               <div className="bidpanel-innercont">
                                 <h6 className="pt-2 text-capitalize">
                                   {post.Year} {post.Make} {post.Model}
                                 </h6>
                                 <span>
                                   <small>Vin #{post.VIN}</small>
                                 </span>
                                 <span>
                                   <small>
                                     Live Auction Date & Time :
                                     {post.Live_Auction_DateTime}
                                   </small>
                                 </span>
                               </div>
                             </div>
                           </a>
                         </div>
                       ))
                     )}
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </section>
);
};